import TextWithTooltip from './text-with-tooltip';

export default TextWithTooltip;
